/* Closing buy — the knife tilts and the buy button leans toward the pointer, on soft springs. */
if (!customElements.get('magnetic-close')) {
  customElements.define('magnetic-close', class extends HTMLElement {
    connectedCallback() {
      if (document.documentElement.classList.contains('reduced-motion') || matchMedia('(hover: none)').matches) return;
      this.knife = this.querySelector('[data-tilt]');
      this.btn = this.querySelector('[data-magnet]');
      this.kr = { z: 0, y: 0, vz: 0, vy: 0 };
      this.br = { z: 0, x: 0, y: 0, vz: 0, vx: 0, vy: 0 };
      this.ptr = null;
      this.onMove = e => { this.ptr = { x: e.clientX, y: e.clientY }; this.wake(); };
      this.onOut = e => { if (!e.relatedTarget) { this.ptr = null; this.wake(); } };
      addEventListener('pointermove', this.onMove, { passive: true });
      document.addEventListener('mouseout', this.onOut);
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.wake(); });
      this.io.observe(this);
    }

    disconnectedCallback() {
      removeEventListener('pointermove', this.onMove);
      document.removeEventListener('mouseout', this.onOut);
      this.io?.disconnect(); cancelAnimationFrame(this.raf);
    }

    wake() { if (!this.raf && this.visible) this.raf = requestAnimationFrame(() => this.tick()); }

    aim(el, maxZ, maxY) {
      if (!this.ptr) return { z: 0, y: 0, x: 0 };
      const r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      const dx = (this.ptr.x - cx) / Math.max(innerWidth / 2, 1), dy = (this.ptr.y - cy) / Math.max(innerHeight / 2, 1);
      const soft = v => Math.tanh(v * 1.4);
      return { z: soft(dy) * soft(dx) * maxZ, y: soft(dx) * maxY, x: soft(-dy) * maxY };
    }

    tick() {
      this.raf = 0;
      const ta = this.aim(this.knife, 4, 9), tb = this.aim(this.btn, 5, 12);
      const stiff = this.ptr ? 0.012 : 0.006, damp = this.ptr ? 0.86 : 0.9;
      let moving = false;
      const spring = (o, key, target) => {
        const vk = 'v' + key;
        o[vk] = (o[vk] + (target - o[key]) * stiff) * damp;
        o[key] += o[vk];
        if (Math.abs(o[vk]) > 0.001 || Math.abs(target - o[key]) > 0.01) moving = true;
      };
      spring(this.kr, 'z', ta.z); spring(this.kr, 'y', ta.y);
      spring(this.br, 'z', tb.z); spring(this.br, 'y', tb.y); spring(this.br, 'x', tb.x);
      this.knife.style.transform = `rotateY(${this.kr.y.toFixed(2)}deg) rotateZ(${this.kr.z.toFixed(2)}deg)`;
      this.btn.style.transform = `perspective(600px) rotateX(${this.br.x.toFixed(2)}deg) rotateY(${this.br.y.toFixed(2)}deg) rotateZ(${(this.br.z * 0.4).toFixed(2)}deg)`;
      if (moving && this.visible) this.raf = requestAnimationFrame(() => this.tick());
    }
  });
}
